import { Component, ElementRef, EventEmitter, Input, OnInit, OnChanges, Output, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
@Component({
  selector: 'app-basic-gridview',
  templateUrl: './basic-gridview.component.html',
  styleUrls: ['./basic-gridview.component.css']
})
export class BasicGridviewComponent implements OnInit, OnChanges {

  private _lstData: any[];
  @Input() set lstData(value: any[]) {
    this._lstData = value;
    this.totalPages = Math.ceil(this.lstData.length / this.recordsPerPage);
    this.currentPage = 1;
    this.firstRecord = (this.lstFilteredData.length === 0 ? 0 : ((this.currentPage * this.recordsPerPage) - this.recordsPerPage) + 1);
    this.lastRecord = (this.recordsPerPage < this.lstData.length) ? this.recordsPerPage : this.lstFilteredData.length;
  }
  get lstData(): any[] {
    return this._lstData;
  }

  @Input() columnsToHide: any = [];
  @Input() gridTitle: string = "";
  @Input() showExcelDownloadOption: boolean = true;
  @Input() showSearchOption: boolean = true;
  @Input() showRecordsPerPageOption: boolean = true;
  @Input() showPagination: boolean = true;
  @Input() showScrollButton: boolean = true;
  @Input() showOuterBox: boolean = true;
  @Input() showRefreshButton: boolean = false;
  @Input() recordsPerPage = 5;
  @Input() hyperlinkCols: any = ['attachment', 'urn'];
  @Input() exportToExcelFileName: string = 'download_result';
  @Input() columnsToExcludeFromExport: any = [];

  @Output() cellClickEvent = new EventEmitter<any>();
  @Output() RefreshEvent = new EventEmitter<any>();
  @Output() dropDownClickEvent = new EventEmitter<any>();
  @Output() headercheckboxClickEvent = new EventEmitter<any>();
  @ViewChild('scrollableGrid') scrollableGrid: ElementRef;

  @Output() selectallClickEvent = new EventEmitter<any>();

  searchInput: string = '';
  lstFilteredData: any = [];
  lstColumns: any = [];
  currentPage = 1;
  totalPages = 1;
  firstRecord = 1;
  lastRecord = 1;
  isMasterSel: boolean;
  sortColumnInfo = { name: '', isOrderAsc: true };

  selectedColIndex: number = -1;
  selectedRowIndex: number = -1;
  records_count: number = 0;
  constructor(private commonService: CommonService) {

  }

  ngOnInit(): void {
    this.totalPages = Math.ceil(this.lstData.length / this.recordsPerPage);
    if (this.lstData.length > 0)
      this.lstColumns = Object.keys(this.lstData[0]);
    this.lstFilteredData = this.lstData;
    this.firstRecord = this.lstFilteredData.length === 0 ? 0 : ((this.currentPage * this.recordsPerPage) - this.recordsPerPage) + 1;
    this.lastRecord = (this.firstRecord - 1 + this.recordsPerPage < this.lstData.length) ? this.firstRecord - 1 + this.recordsPerPage : this.lstFilteredData.length;
  }
  ngOnChanges(): void {
    this.records_count = this.lstData.length
    if (this.lstData != null && this.lstData != undefined) {
      this.totalPages = Math.ceil(this.lstData.length / this.recordsPerPage);

      if (this.lstData.length > 0)
        this.lstColumns = Object.keys(this.lstData[0]);

      this.lstFilteredData = this.lstData;
      this.firstRecord = this.lstFilteredData.length === 0 ? 0 : (((this.currentPage * this.recordsPerPage) - this.recordsPerPage) + 1);
      this.lastRecord = (this.recordsPerPage < this.lstFilteredData.length) ? this.recordsPerPage : this.lstFilteredData.length;
    }
    // this.cdref.detectChanges();
  }
  onCellClick(columnName: String, rowData: any, rowIndex: number) {
    this.cellClickEvent.emit({ columnName: columnName, rowData: rowData, rowIndex });
  }

  getCellStyle(col: string): Object {
    if (this.hyperlinkCols.includes(col.toLowerCase())) {
      return { 'cursor': 'pointer', 'text-decoration': 'underline', 'color': '#76449b', 'font-weight': 600 };
    } {
      return {};
    }
  }

  scrollGrid(direction: string): void {
    if (direction == 'next') {
      this.scrollableGrid.nativeElement.scrollLeft += 500;
    } else {
      this.scrollableGrid.nativeElement.scrollLeft -= 500;
    }

  }

  sortByColumn(column: string) {
    let sortOrder = false;
    if (this.sortColumnInfo.name == column)
      sortOrder = !this.sortColumnInfo.isOrderAsc;
    else
      this.sortColumnInfo.name = column;

    this.sortColumnInfo.isOrderAsc = sortOrder;

    if (sortOrder)
      this.lstData.sort((a, b) => a[column] < b[column] ? -1 : a[column] > b[column] ? 1 : 0);
    else
      this.lstData.sort((a, b) => b[column] < a[column] ? -1 : b[column] > a[column] ? 1 : 0);
  }

  changePage(direction: string) {
    if (direction == 'prev')
      this.currentPage = this.currentPage == 1 ? 1 : this.currentPage - 1;
    if (direction == 'next')
      this.currentPage = this.currentPage == this.totalPages ? this.totalPages : this.currentPage + 1;

    this.firstRecord = ((this.currentPage * this.recordsPerPage) - this.recordsPerPage) + 1;
    this.lastRecord = (this.firstRecord - 1 + this.recordsPerPage < this.lstFilteredData.length) ? this.firstRecord - 1 + this.recordsPerPage : this.lstFilteredData.length;


    // this.firstRecord = ((this.currentPage * this.recordsPerPage) - this.recordsPerPage) + 1;
    // this.lastRecord = (this.firstRecord - 1 + this.recordsPerPage < this.lstFilteredData.length) ? this.firstRecord - 1 + this.recordsPerPage : this.lstFilteredData.length;
  }

  changeRecordsPerPage() {
    this.totalPages = Math.ceil(this.lstFilteredData.length / this.recordsPerPage);
    this.currentPage = 1;


    this.firstRecord = this.lstFilteredData.length == 0 ? 0 : 1;
    this.lastRecord = (this.recordsPerPage < this.lstFilteredData.length) ? this.recordsPerPage : this.lstFilteredData.length;
  }

  onSearchChange() {
    this.lstFilteredData = this.lstData.filter(x => {
      let isContains = false;
      this.lstColumns.forEach(c => {
        if (x[c] != undefined && x[c] != null && x[c].toString().toLowerCase().includes(this.searchInput.toLowerCase())) { isContains = true; }
      });
      return isContains;
    });
    this.changeRecordsPerPage();
  }

  HeaderCheckBoxChanged(model: any) {

    // this.lstData.forEach(d => {
    //   d.action_checkbox_button = this.isMasterSel;
    // })

    if (model.checked == true) {
      // this.isMasterSel = true;
      this.lstData.forEach(d => {
        d.action_checkbox_button = true;


      })
      this.selectallClickEvent.emit({ value: "true" });
    } else {
      this.lstData.forEach(d => {
        d.action_checkbox_button = false;

      })
      this.selectallClickEvent.emit({ value: "false" });
    }
    this.headercheckboxClickEvent.emit({ model });
    //this.isAllSelected()
  }
  downloadExcel() {

    let lstDownloadData = [];

    if (this.columnsToExcludeFromExport != undefined && this.columnsToExcludeFromExport.length > 0) {
      let columns = Object.keys(this.lstFilteredData[0]);

      this.lstFilteredData.forEach(row => {
        let newRow: any = {};

        columns.forEach(col => {
          if (col != 'checkbox' && !this.columnsToExcludeFromExport.includes(col)) {
            newRow[col] = row[col];
          }
        });

        lstDownloadData.push(newRow);
      });
    }
    else {
      lstDownloadData = this.lstFilteredData;
    }
    this.commonService.exportAsExcelFile(lstDownloadData, this.exportToExcelFileName);
  }
  onSelectionChange(event: any, index: number, colName: string) {

    this.lstFilteredData[index][colName].forEach(element => {
      element.selected = false;
    })
    let currentIndex = this.lstFilteredData[index][colName].findIndex(a => a.value === event.value)
    this.lstFilteredData[index][colName][currentIndex].selected = true;

    this.dropDownClickEvent.emit({ event, index, colName });
  }

  onSelectionMultiChange(event: any, index: number, colName: string) {
    this.lstFilteredData[index][colName].forEach(element => {
      element.selected = false;
    })

    event?.forEach(ele => {
      let currentIndex = this.lstFilteredData[index][colName].findIndex(a => a.value === ele.value)
      this.lstFilteredData[index][colName][currentIndex].selected = true;
    })


  }
  compareObjects(o1: any, o2: any) {
    if (o1.selected == true)
      return true;
    else return false
  }

}
